export const testing = 'testing';

// setting the baseurl for api call from here

export const API_BASE_PATH: string | undefined = `${process.env.REACT_APP_API_BASE_PATH}/`;
export const GOOGLE_MAP_API_KEY: string | undefined = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
